import { render, staticRenderFns } from "./PostInstagram.vue?vue&type=template&id=86fafada&"
import script from "./PostInstagram.vue?vue&type=script&lang=js&"
export * from "./PostInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports